<template>
  <div class="detail">
    <s-g-nav></s-g-nav>
    <div class="detail__content">
      <a
        class="external-link"
        :href="codeLink">
        <svg
          class="external-link__icon"
          aria-labelledby="simpleicons-github-dark-icon"
          role="img"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg">
          <title id="simpleicons-github-dark-icon" lang="de">GitHub Icon</title>
          <!-- eslint-disable-next-line -->
          <path fill="#7F8C8D" d="M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12"></path>
        </svg>
        Komponente auf Github</a>
      <component
        :is="detailComponent"
        :key="name"
      ></component>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Detail',
  components: {
    SGNav: () => import('@/sg/components/SGNav.vue'),
  },
  data() {
    return {
      // name: this.$route.params.component,
      detailComponent: {},
    };
  },
  computed: {
    /* detailComponent() {
      return () => this.importComponent(this.name);
    }, */
    name() {
      return this.$route.params.component;
    },
    codeLink() {
      const uri = 'https://github.com/FitX/touchpoint-components/tree/master/vue/src/lib-components';
      return `${uri}/${this.name}.vue`;
    },
  },
  created() {
    this.changeComponent();
  },
  watch: {
    name() {
      this.changeComponent();
    },
  },
  methods: {
    importComponent(name = this.name) {
      return import(`@/sg/documentation/${name}.vue`)
        .then((m) => m.default)
        // .catch((err) => import ('404_component_does_not_exist'));
        .catch(() => this.$router.push('/'));
    },
    changeComponent() {
      this.detailComponent = () => this.importComponent();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';

.detail {
  display: grid;
  grid: 'nav' auto
        'content' 1fr / 1fr;
  grid-gap: 2rem;

  @media (min-width: 800px) {
    grid: 'nav content' 1fr / 200px 1fr;
  }
}

.external-link {
  display: inline-flex;
  align-items: center;
  color: var(--color-text);

  &__icon {
    width: 1rem;
    padding-right: 0.2rem;
  }
}
</style>
